<template>
    <dx-grid
        :url="url"
        :columns="columns"
        :title="title"
        :actions="actions"
        :onRowClicked="onRowClicked"
        navigationPath="onRowClicked"
        navigationField="onRowClicked"
        :selectionEnabled="true"
        :beforeSetupGrid="beforeSetupGrid"
        ref="grid"
        :summaryOptions="{
            enabled: true,
            columns: [
                'credit',
                'debit',
                'actualBalance',
                'balance',
                'previousBalance',
                'totalPaid',
                'paid',
                'scheduledPayments',
                'bungalowCharge',
                'bedroomCharge',
                'airConditionersCharge',
                'washerCharge',
                'dryerCharge',
            ],
        }"
    ></dx-grid>
</template>

<script>
import { formatCurrency } from "../utils/helpers.js";

export default {
    data: () => ({
        title: "Billing Accounts",
        columns: [
            {
                field: "name",
                label: "Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "accountID",
                label: "Account ID",
                link: "LapidusBillingView",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "bungalow",
                label: "Bungalow",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                calculateSortValue: function(rowData) {
                    return rowData.bungalowSort;
                },
            },
            {
                field: "note",
                label: "Note",
                format: "",
                type: "number",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "homePhone",
                label: "Home Phone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "address1",
                label: "Address",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "city",
                label: "City",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "state",
                label: "State",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "zipCode",
                label: "Zip Code",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "cellPhone",
                label: "Cellphone",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "date",
                label: "Date",
                type: "date",
                format: "",
                visible: true,
                filterType: "",
                format: "MM/dd/yyyy",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "actualBalance",
                label: "Actual Balance",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "balance",
                label: "Balance",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "previousBalance",
                label: "Previous Balance",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "debit",
                label: "Billed",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "totalPaid",
                label: "Total Paid",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "paid",
                label: "Paid",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "scheduledPayments",
                label: "ScheduledPayments",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "credit",
                label: "Credit",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "bungalowCharge",
                label: "Bungalow Charge",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "bedroomCharge",
                label: "Bedroom Charge",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "airConditionersCharge",
                label: "Air Conditioners Charge",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "washerCharge",
                label: "Washer Charge",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "dryerCharge",
                label: "Dryer Charge",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "maintenanceCharge",
                label: "Maintenance Charge",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "splitCharge",
                label: "Split Charge",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Non UTA",
                field: "nonUTA",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: false,
            },
        ],

        actions: [],

        regID: "",
        url: "",
    }),
    async created() {},
    methods: {
        async beforeSetupGrid() {
            await this.loadRegID();

            const terms = await this.getTerms();

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: terms.map((t) => t.term),
                value: this.regID,
                onSelected: this.onTermSelected,
            });

            this.actions.push({
                text: "Print Report",
                name: "PrintReport",
                action: this.printReport,
                showOnSelection: true,
            });

            this.actions.push({
                text: "Add Family",
                action: this.addFamily,
            });

            this.url = "lapidus?regID=" + this.regID;
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/lapidusDayCamp/getRegID");
        },
        async getTerms() {
            return await this.$http.get("api/lapidusDayCamp/getRegTerms");
        },
        async onRowClicked(row) {
            this.$router.push({
                name: "LapidusBillingView",
                params: { id: row.accountID, reg_id: row.regID },
            });
        },
        addFamily() {
            this.$router.push({
                name: "LapidusRegister",
            });
        },
        onTermSelected(value) {
            this.regID = value;
            this.url = "lapidus?regID=" + this.regID;

            this.$refs.grid.reloadDataSource(this.url);
        },
        async printReport() {
            let accounts = this.$refs.grid.getSelectedRowsData();

            const columnSort = this.columns.find((c) => {
                const sort = this.$refs.grid.grid.columnOption(
                    c.field,
                    "sortOrder",
                );

                if (!sort) return false;

                return true;
            });

            if (columnSort) {
                const sortOrder = this.$refs.grid.grid.columnOption(
                    columnSort.field,
                    "sortOrder",
                );

                accounts = accounts.sort((a, b) => {
                    if (sortOrder == "desc") {
                        if (a[columnSort.field] < b[columnSort.field]) {
                            return 1;
                        }
                        if (a[columnSort.field] > b[columnSort.field]) {
                            return -1;
                        }
                        return 0;
                    } else {
                        if (a[columnSort.field] < b[columnSort.field]) {
                            return -1;
                        }
                        if (a[columnSort.field] > b[columnSort.field]) {
                            return 1;
                        }
                        return 0;
                    }
                });
            }

            if (!accounts.length) {
                this.$notify({
                    group: "notification",
                    text: "No Accounts Selected.",
                    type: "error",
                });

                return;
            }

            const selection = accounts.map((a) => a.accountID);

            try {
                this.processing = true;

                const response = await this.$http({
                    url:
                        "api/lapidus/StatementReport?term=" +
                        this.regID +
                        "&selection=" +
                        selection,
                    method: "POST",
                    data: {},
                    responseType: "blob",
                });

                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Lapidus Report.pdf");
                document.body.appendChild(link);
                link.click();

                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
</style>
